import template from './mapLocationAddPage.html';
import controller from './mapLocationAddPage.controller';
import './mapLocationAddPage.scss';

let mapLocationAddPageComponent = {
  restrict: 'E',
  bindings: {
    locationFilters: '<',
    accesses: '<',
    locationTypes: '<'
  },
  template,
  controller
};

export default mapLocationAddPageComponent;
